import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ResponsiveBar } from '@nivo/bar'
import SkySparkGrid from '../../api/SkySparkGrid'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import InfLoader from "../../infLoad/";


export const JaarVergelijking = ({ pointList }) => {
    const { siteId } = useParams()

    //prepare selected point; default first in pointList
    const [selectedPoint, setSelectedPoint] = useState(pointList[0])

    //energy benchmarking per month 
    const [monthGrid, setMonthGrid] = useState({})
    const [monthGridLoading, setMonthGridLoading] = useState(true)

    //energy usage total per year
    const [yearGrid, setYearGrid] = useState({})
    const [yearGridLoading, setYearGridLoading] = useState(true)

    //declare event
    const onPointChangeEvent = (event) => { setSelectedPoint(event.target.value) }

    //if pointList is updated, re-set selected point
    useEffect(() => {
        setSelectedPoint(pointList[0])
    }, [pointList])

    //if either pointList or selectedPoint is updated, set loading state
    useEffect(() => {
        //only set loading state to true if currently false
        if (!monthGridLoading) setMonthGridLoading(true)
        if (!yearGridLoading) setYearGridLoading(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedPoint])

    //if selectedPoint is updated, launch API calls
    useEffect(() => {
        //get current date as string
        const today = moment().format("YYYY-MM-DD")
        //prepare energy data visualized per month-of-year
        SkySparkGrid(`api_benchmarkYearUsage(@${siteId}, @${selectedPoint["id"]["val"]}, ${today})`).then((response) => {
            if (response.data != null && response.data["rows"] !== null && response.data["rows"].length !== 0) {
                setMonthGrid(response.data)
                setMonthGridLoading(false)
            }
        })
        //prepare energy data visualized per year
        SkySparkGrid(`api_benchmarkYearUsage2(@${siteId}, @${selectedPoint["id"]["val"]}, ${today})`).then((response) => {
            if (response.data != null && response.data["rows"] !== null && response.data["rows"].length !== 0) {
                setYearGrid(response.data)
                setYearGridLoading(false)
            }
        })
    }, [selectedPoint, siteId])

    return (
        <Grid container gap={2} wrap='nowrap' sx={{ marginBottom: "15px" }}>
            {/* MONTH-OF-YEAR VISUALISATION */}
            <Grid item xl={8} xs={8} sx={{ backgroundColor: '#f2f0f0', height: '500px', boxShadow: 3 }}>
                <Box sx={{ width: '100%', height: '85%' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', m: '8px' }}>
                        <FormControl sx={{ width: '275px', textAlign: 'center', mt:'8px' }}>
                            <InputLabel shrink={true} sx={{color:'black'}} id="pointSelectorLabel">Selecteer punt</InputLabel>
                            <Select
                                labelId='pointSelectorLabel'
                                id={`point-selection-${siteId}`}
                                value={selectedPoint}
                                onChange={(event) => onPointChangeEvent(event)}
                                sx={{ width: '100%', height: '30px', color: '#141414', fontFamily:'Source Sans Pro,sans-serif !important'}}
                                label='Selecteer punt'
                            >
                                { pointList.map((point) => <MenuItem key={point.id.val} value={point}>{point.id.dis}</MenuItem>) }
                            </Select>
                        </FormControl>
                    </Box>
                    <Typography variant='h5' textAlign='center' fontWeight='bold' sx={{color:'#141414'}}>Jaarvergelijking verbruik per maand</Typography>
                    <Typography variant='h6' textAlign='center' sx={{color:'#141414'}}>{selectedPoint["id"]["dis"] !== undefined ? (selectedPoint['id']['dis']) : ('No meter')}</Typography>
                    {
                        monthGridLoading ? <Box sx={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}><InfLoader/></Box>
                            :
                            (<Box sx={{ width: '100%', height: {xl:'98%', lg:'98%', md:'94%', sm:'92%', xs:'92%'} }}>
                            <ResponsiveBar
                                data={monthGrid["rows"]}
                                keys={monthGrid["meta"]["cols"]}
                                indexBy="id"
                                margin={{ top: 60, right: 30, bottom: 50, left: 90 }}
                                padding={0.15}
                                groupMode="grouped"
                                valueScale={{ type: 'linear' }}
                                indexScale={{ type: 'band', round: true }}
                                colors={point => monthGrid["cols"].find((row) => row["name"] === point.id)["meta"]["color"]}
                                tooltip={(point) => {
                                    const pointName = monthGrid["cols"].find(col => col["name"] === point.id)["meta"]["dis"]
                                    const unit = monthGrid["cols"].find(col => col["name"] === point.id)["meta"]["unit"]
                                    return (
                                        <Box sx={{ backgroundColor: "white", color: "black", padding: "10px", borderRadius: "5px", boxShadow:3, opacity:0.9, display:'flex'}}>
                                             <Box sx={{width:'10px', height:'20px', backgroundColor: point.color, margin:'auto', marginRight:'9.9px', borderRadius:'3px'}}></Box>
                                            <Typography sx={{marginTop:'1px'}}>{pointName}: {Math.round(point.formattedValue)}{unit}</Typography>
                                        </Box>
                                    )
                                }}
                                axisBottom={{
                                    tickSize: 5,
                                    tickPadding: 5,
                                    tickRotation: 0,
                                    legendPosition: 'middle',
                                    legendOffset: 32,
                                    truncateTickAt: 0
                                }}
                                axisLeft={{
                                    format: (value) => `${value} ${selectedPoint["unit"]}`,
                                    tickSize: 5,
                                    tickPadding: 0,
                                    tickRotation: 0,
                                    legendPosition: 'middle',
                                    legendOffset: -40,
                                    truncateTickAt: 5
                                }}
                                label={false}
                                legends={[
                                    {
                                        dataFrom: 'keys',
                                        data: monthGrid["meta"]["cols"].map((id) => ({
                                            id,
                                            color: monthGrid["cols"].find((row) => row["name"] === id)["meta"]["color"],
                                            label: monthGrid["cols"].find((row) => row["name"] === id)["meta"]["dis"]
                                        })),
                                        anchor: 'top-right',
                                        direction: 'row',
                                        justify: false,
                                        translateX: 0,
                                        translateY: -60,
                                        itemsSpacing: -15,
                                        itemWidth: 90,
                                        itemHeight: 20,
                                        itemDirection: 'right-to-left',
                                        symbolShape: 'circle',
                                        itemOpacity: 0.85,
                                        symbolSize: 15,
                                        effects: [
                                            {
                                                on: 'hover',
                                                style: {
                                                    itemOpacity: 1
                                                }
                                            }
                                        ]
                                    }
                                ]}
                            />
                            </Box>)
                    }
                </Box>
            </Grid>

            {/* YEAR-DATA VISUALISATION */}
            <Grid item xl={4} xs={4} sx={{ backgroundColor: '#f2f0f0', height: '500px', boxShadow: 3 }}>
                <Box sx={{ width: '250px', height: '30px' }} />
                <Typography variant='h5' sx={{fontSize:{xl:'16px', lg:'16px', md:'13px', sm:'13px', xs:'13px'}}}textAlign='center' fontWeight='bold'>Jaarvergelijking verbruik per jaar</Typography>
                <Typography variant='h6' sx={{fontSize:{xl:'14px', lg:'14px', md:'11px', sm:'11px', xs:'11px'}}}textAlign='center' >{selectedPoint["id"]["dis"]}</Typography>
                {
                    yearGridLoading ? <Box sx={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}><InfLoader/></Box>
                        :
                        (<Box sx={{ width: '100%', height: {xl:'89%', lg:'89%', md:'87%', sm:'85%', xs:'85%'} }}>
                            <ResponsiveBar
                                data={yearGrid["rows"]}
                                keys={yearGrid["meta"]["cols"]}
                                indexBy="id"
                                margin={{ top: 60, right: 30, bottom: 50, left: 90 }}
                                padding={0.15}
                                groupMode="grouped"
                                valueScale={{ type: 'linear' }}
                                indexScale={{ type: 'band', round: true }}
                                colors={point => yearGrid["cols"].find((row) => row["name"] === point.id)["meta"]["color"]}
                                tooltip={(point) => {
                                    const pointName = yearGrid["rows"].find((row) => row["id"] === point.data.id)["id"]
                                    const unit = yearGrid["cols"].find(col => col["name"] === point.id)["meta"]["unit"]
                                    return (
                                        <Box sx={{ backgroundColor: "white", color: "black", padding: "10px", borderRadius: "5px", boxShadow:3, opacity:0.9, display:'flex'}}>
                                             <Box sx={{width:'10px', height:'20px', backgroundColor: point.color, margin:'auto', marginRight:'9.9px', borderRadius:'3px'}}></Box>
                                             <Typography sx={{marginTop:'1px'}}>{pointName}: {Math.round(point.formattedValue)}{unit}</Typography>
                                        </Box>
                                    )
                                }}
                                axisBottom={{
                                    tickSize: 5,
                                    tickPadding: 5,
                                    tickRotation: 0,
                                    legendPosition: 'middle',
                                    legendOffset: 32,
                                    truncateTickAt: 0
                                }}
                                axisLeft={{
                                    format: (value) => `${value} ${selectedPoint["unit"]}`,
                                    tickSize: 5,
                                    tickPadding: 0,
                                    tickRotation: 0,
                                    legendPosition: 'middle',
                                    legendOffset: -40,
                                    truncateTickAt: 5
                                }}
                                label={false}
                                legends={[
                                    {
                                        dataFrom: 'keys',
                                        data: yearGrid["meta"]["cols"].map(id => ({
                                            id,
                                            color: yearGrid["cols"].find((row) => row["name"] === id)["meta"]["color"],
                                            label: 'Totalen per jaar'
                                        })),
                                        anchor: 'top-right',
                                        direction: 'column',
                                        justify: false,
                                        translateX: 0,
                                        translateY: -40,
                                        itemsSpacing: 5,
                                        itemWidth: 90,
                                        itemHeight: 20,
                                        itemDirection: 'right-to-left',
                                        symbolShape: 'circle',
                                        itemOpacity: 0.85,
                                        symbolSize: 15,
                                        effects: [
                                            {
                                                on: 'hover',
                                                style: { itemOpacity: 1 }
                                            }
                                        ]
                                    }
                                ]}
                            />
                        </Box>)
                }
            </Grid>
        </Grid>
    )
}